module.exports = __webpack_public_path__ + "static/media/dental.bdc67892.svg";